export default defineNuxtPlugin(() => {
  const PROD_HOST = 'mm.ru';
  const isProdHost = process.client && window.location.host === PROD_HOST;
  
  if (!isProdHost) {
    return;
  }

  (function(m: any, e: any, t: any, r: any, i: any, k?: any, a?: any) {
    m[i] = m[i] || function() {
      (m[i].a = m[i].a || []).push(arguments)
    };
    m[i].l = 1 * (new Date() as any);
    for (var j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) { 
        return; 
      }
    }
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

  (window as any).ym(46856709, 'init', {
    webvisor: true,
    trackHash: true,
    clickmap: true,
    ecommerce: "dataLayer",
    accurateTrackBounce: true,
    trackLinks: true
  });
});
